// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const headerLogo = document.querySelector('.js-scroll-logo');
const burgerMenuBtn = document.getElementById('js-menu-trigger');
const burgerMenuClose = document.getElementById('js-close-menu');
const burgerMenu = document.getElementById('burger-menu');

(function(){


	document.addEventListener("DOMContentLoaded", function(event) {
		window.onload = onLoad();
	});

	/* Main Nav */

	burgerMenuBtn.addEventListener('click', () =>{
		burgerMenu.classList.add('open');
		document.body.classList.add('no-scroll');
	});

	burgerMenuClose.addEventListener('click', () =>{
		burgerMenu.classList.remove('open');
		document.body.classList.remove('no-scroll');
	});

    let itemsMenu = document.querySelectorAll('.primary-nav li');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			if(screen.width > 680) {
				itemMenu.addEventListener('mouseenter',()=>{
					itemMenu.classList.add('hover');
					itemMenu.querySelector('.submenu').classList.add('show');
				});
				itemMenu.addEventListener('mouseleave',()=>{
					itemMenu.classList.remove('hover');
					itemMenu.querySelector('.submenu').classList.remove('show');
				})
			} else {
				let mainItem = itemMenu.querySelector('a');
				mainItem.addEventListener('click', (e) => {
					e.preventDefault()
				});
				itemMenu.addEventListener('click',()=>{
					itemMenu.classList.toggle('hover');
					itemMenu.querySelector('.submenu').classList.toggle('show');
				});
			}
		}
	})


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


	/* vanilla JS fancybox */
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open');
				document.body.classList.add('no-scroll');
			});

		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}

		let allLbxWraps = document.querySelectorAll('.lightbox');

		for(const lbxWrap of allLbxWraps) {
			lbxWrap.addEventListener('click', (e) => {
				const innerWrap = lbxWrap.querySelector('.lightbox-wrap') ;
				if(!innerWrap.contains(e.target)) {
					allLbxWraps.forEach(el => el.classList.remove('open'));
					document.body.classList.remove('no-scroll');
				}
			})
		}

	};
	

	/* navigation images on hover */
	if(document.getElementById('navImages')){
		
		let allMainLinks = document.getElementById('primary-nav').querySelectorAll('.primary-link')
		let allMainImages = document.getElementById('navImages').getElementsByTagName('img');
		let prevMainImage = allMainImages[0];
		prevMainImage.src = prevMainImage.dataset.src;

		allMainLinks.forEach((link,index) => {
			
			link.addEventListener('mouseenter',function(){
				if (!allMainImages[index]) return;
				
				prevMainImage.parentElement.classList.remove('active');

				if (!allMainImages[index].src)
					allMainImages[index].src = allMainImages[index].dataset.src;

				allMainImages[index].parentElement.classList.add('active');

				prevMainImage = allMainImages[index];
			})
		});
	}


	/* mobile gallery videos */
	const galleryVideos = document.querySelectorAll('.lbx-main-gallery');
	if(screen.width < 600 && galleryVideos) {
		galleryVideos.forEach(video => {
			video.classList.remove('lbx-main-gallery')
		})
	}

})();

function onLoad(){

	if(!document.getElementById('gallery') && !document.getElementById('attractions') && document.getElementsByClassName('sitemap').length < 1 && document.getElementsByClassName('terms-and-conditions').length < 1 && document.getElementsByClassName('no-hero').length < 1){
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
			scaleImagesOnScroll();
		})
	} else {
		document.getElementById('header').classList.add('scroll');
		changeSrc(headerLogo.getElementsByTagName('img')[0]);
	}
}


function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			changeSrc(headerLogo.getElementsByTagName('img')[0]);
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			changeSrc(headerLogo.getElementsByTagName('img')[0]);
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function scaleImagesOnScroll() {
    let images = document.querySelectorAll(".js-scale-img");
    if (images && screen.width > 900) {
        images.forEach(el => {
            const rect = el.getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const isInViewport = rect.top <= viewportHeight && rect.bottom >= 0;
            
            if (isInViewport) {
                const distanceToTop = rect.top;
                const scaleFactor = 1 + (1.15 - 1) * (1 - distanceToTop / viewportHeight);
                el.style.transform = "scale(" + scaleFactor + ")";
            }
        });
    }
}

function changeSrc(elem) {
	let target = elem.getAttribute('data-scroll');
	let currentSrc = elem.getAttribute('src');

	elem.setAttribute('src', target);
	elem.setAttribute('data-scroll', currentSrc);
}